import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { User, Building2, ShieldCheck } from "lucide-react";

const zones = [
  { to: "/app/home", match: "/app", icon: User, label: "Kandidát", id: "switch-candidate" },
  { to: "/company", match: "/company", icon: Building2, label: "Firma", id: "switch-company" },
  { to: "/admin", match: "/admin", icon: ShieldCheck, label: "Admin", id: "switch-admin" },
];

export function AdminSwitcher() {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  if (!user || user.role !== "admin") return null;
  // Never overlay the mandatory entry/public pages (landing, login, register…)
  const hidden = ["/", "/login", "/register", "/pending"];
  if (hidden.includes(loc.pathname) || loc.pathname.startsWith("/p/") || loc.pathname.startsWith("/shared/")) return null;

  return (
    <div data-testid="admin-switcher"
      className="fixed bottom-24 right-4 md:bottom-6 md:right-6 z-[80] flex gap-1 rounded-full bg-white/95 backdrop-blur-md border border-slate-200 shadow-xl p-1">
      {zones.map((z) => {
        const active = loc.pathname.startsWith(z.match);
        return (
          <button key={z.to} data-testid={z.id} onClick={() => nav(z.to)}
            title={z.label}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${active ? "bg-blue-700 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
            <z.icon size={15} />
            <span className="hidden sm:inline">{z.label}</span>
          </button>
        );
      })}
    </div>
  );
}
